
import { FaCheck } from 'react-icons/fa'

import ContactButton from '../components/contactbutton'


const NaasCard = ({ active, title, description, image, included }) => {
    return (
        <div
            aria-hidden={!active}
            className={`card [grid-area:1/1] grid overflow-hidden transition-opacity duration-500 motion-reduce:transition-none md:grid-cols-2 ${active ? "opacity-100" : "pointer-events-none opacity-0"}`}
        >
            <div className="flex flex-col gap-5 p-6 sm:gap-6 sm:p-10">
                <div className="flex flex-col gap-2">
                    <h3 className="text-2xl font-semibold tracking-tight sm:text-3xl">
                        Ace<span className="text-sky-500">{title.replace('Ace', '')}</span>
                    </h3>
                    <p className="text-slate-600 dark:text-slate-400">{description}</p>
                </div>

                <ul className="flex flex-col gap-2.5 text-sm sm:gap-3 sm:text-base">
                    {included.map((item) => (
                        <li key={item} className="flex items-center gap-3">
                            <span className="flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-sky-500/15 text-sky-500">
                                <FaCheck size={10} />
                            </span>
                            {item}
                        </li>
                    ))}
                </ul>

                <div className="mt-auto pt-2">
                    <ContactButton>Kontakta oss</ContactButton>
                </div>
            </div>
            <img className="hidden h-full w-full object-cover md:block" src={image} alt={title} />
        </div>
    )
}


export default NaasCard;
